<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <table-cadu
        class="hierarquia-adm"
        nameTab="hierarquiaAdministracao"
        :loading="loading"
        :showDownload="true"
        :custom="true"
        showFiltro
        :showCheck="false"
        :ordemProp="ordem"
        :rows="rows"
        :rowsHeader="rowsHeader"
        :disabledButtons="[false, true, false]"
        :pagina="pagina"
        :qtPaginas="qtPaginas"
        :qtResultados="qtResultados"
        :items="['05', '10', '15', '20']"
        @change-element="changeSelect"
        @change-page="page => changePage(page.currentPage)"
        @ordena="ordem => ordernaTable(ordem)"
        @filtro-click="$emit('filtro-click')"
        @download="downloadHierarquia"
        @clickButton="clickButton"
      />
    </v-col>
    <error-modal
      v-model="error"
      :errObj="errObj"
    />
    <ModalHierarquia
      @reload="getHierarquias()"
      v-model="showModal"
      :idUnimed="idUnimedTabela"
      :codigoUnimed="codigoUnimedTabela"
      ref="modalHierarquia"
    />
    <overlay-loading :value="isLoadingOverlay"/>
  </v-row>
</template>

<script>
import Hierarquia from '@/services/Hierarquia'
import ModalHierarquia from './ModalHierarquia'
/* eslint-disable */
export default {
  components: {
    ModalHierarquia
  },
  props: {
    idUnimed: {
        type: [String, Number],
        required: false,
        default: ''
    },
    idHierarquia: {
        type: [String, Number],
        required: false,
        default: ''
    }
  },
  data() {
    return {
      rowsHeader: [
        { text: "Unimed", icon: "repeat" },
        { text: "Hierarquia 1", icon: "repeat" },
        { text: "Hierarquia 2", icon: "repeat" },
        { text: "Hierarquia 3", icon: "repeat" },
        { text: "Segunda filiação"},
        { text: "Data Atualização", icon: "repeat" }
      ],
      rows: [],
      ordem: "asc",
      ordemStatus: "unimedId",
      tokenBearer: localStorage.getItem("tokenBearer"),
      loading: false,
      error: false,
      errObj: {},
      showModal: false,
      idUnimedTabela: '',
      codigoUnimedTabela: '',
      isLoadingOverlay: false,
      pagina: 1,
      qtResultados: -1,
      qtPaginas: -1,
      tamanhoPagina: 5
    };
  },
  beforeMount () {
    this.getHierarquias()
  },
  methods: {
    changeSelect (element) {
      this.pagina = 1
      this.tamanhoPagina = element
      this.getHierarquias()
    },
    changePage (page) {
      this.pagina = page
      this.getHierarquias()
    },
    async downloadHierarquia () {
      const hierarquia = new Hierarquia(this.tokenBearer, this.$appConfig.config.API, 0);

      try {
        this.isLoadingOverlay = true
        let response = await hierarquia.download(this.getArgs())
        let content = response.headers['content-disposition']
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', content.substring(content.indexOf('"') + 1, content.lastIndexOf('"')))
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        console.error(err)
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      } finally {
        this.isLoadingOverlay = false
      }
    },
    clickButton (obj) {
      if (obj.type === 'edit') {
        this.idUnimedTabela = this.rows[obj.index].unimed.id
        this.codigoUnimedTabela = this.rows[obj.index].unimed.codigo
        this.$nextTick(async () => {
          await this.$refs.modalHierarquia.start()
        })
      }
    },
    async getHierarquias (pagina = 0) {
        if (pagina !== 0) this.pagina = pagina
        this.loading = true    
        const hierarquia = new Hierarquia(this.tokenBearer, this.$appConfig.config.API, 0);

        try {
            let responseGet = await hierarquia.getHierarquiaAdm(this.getArgs())
            const data = responseGet.data
            this.rows = this.removerSegundaHierarquiaIgnorada(data.conteudo);
            this.qtResultados = data.qtResultados
            this.pagina = data.pagina
            this.qtPaginas = data.qtPaginas
        } catch (err) {
            console.error(err)
            this.error = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
        } finally {
            this.loading = false;
        }
    },
    removerSegundaHierarquiaIgnorada(rows) {
      let result = [];
      rows.forEach(row => {
          if(row.ignorarAlvo) {
            row.hierarquia2 = null;
          }
          result.push(row);
      });
      return result;
    },
    getArgs () {
      let args = this.geradorParams(
          {
            name: 'ordenacao',
            value: this.ordemStatus || ''
          },
          {
            name: 'direcaoOrdenacao',
            value: this.ordem || ''
          },
          {
            name: 'idUnimed',
            value: this.idUnimed || ''
          },
          {
            name: 'idUnimedHierarquia',
            value: this.idHierarquia || ''
          },
          {
            name: 'pagina',
            value: this.pagina
          },
          {
            name: 'tamanhoPagina',
            value: this.tamanhoPagina
          }
      )
      return args
    },
    geradorParams (...params) {
      let str = ''
      for (let p of params) {
          if (p.value) {
              str += `${p.name}=${p.value}&`
          }
      }
      if (params.length > 0) {
          str = str.substring(0, str.length - 1)
      }
      return str
    },
    ordernaTable(obj) {
      this.ordem = obj.ordem
      obj.index == 0
        ? (this.ordemStatus = "unimedId")
        : obj.index == 1
        ? (this.ordemStatus = "hierarquia1")
        : obj.index == 2
        ? (this.ordemStatus = "hierarquia2")
        : obj.index == 3
        ? (this.ordemStatus = "hierarquia3")
        : obj.index == 4
        ? (this.ordemStatus = "dataUltimaAtualizacao")
        : (this.ordemStatus = "unimed")

      this.paginate();
    },
    paginate() {
      this.getHierarquias()
    }
  }
};
</script>

<style lang="sass">
.hierarquia-adm > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.hierarquia-adm > .table-cadu > .table
  max-height: 350px
  overflow: auto
  table
    width: 100%
</style>